/////////////////////////////////////////////////////////////////////////////////////////////
// This is a custom control, it has to have the following props in order to function:
// - value
// - onChange
// - onBlur
// You can take advantage of the following props as well to show the label, errors, disable, etc
// - label
// - showError
// - errorMessage
// - onError
// - disable
// - required
// You can use the ControlProps interface for your props (like this example does).

import { Box, Button, Stack, useTheme } from "@mui/material";
import { ButtonProps } from "@mui/material/Button";
import { ExtendedControlProps } from "@sis/react-library";

export const FormSamplesRockPaperScissorsInput = ({
    id,
    value,
    label,
    showError,
    errorMessage,
    required,
    disabled,
    disableForm,
    onChange,
    onBlur,
    onError
}: ExtendedControlProps) => {

    const theme = useTheme();

    const getButtonVariant = (buttonFor: string) => {
        return (buttonFor === value) ? 'contained' : 'outlined';
    }

    const handleOnClick = (buttonFor: string) => {
        // Raise a custom error if dynamite is picked, This will disallow the form to be submitted
        // unil the error is fixed
        onError!(buttonFor === "D", "Picking dynamite is cheating - can't submit");

        // Allow any below
        // eslint-disable-next-line
        const event: any = {
            target: {
                value: buttonFor
            }
        }
        if (onChange) { onChange(event); }
        if (onBlur) { onBlur(event); } // As this control has no text focus, we need to blur when do a change as well
    }

    const buttonProps: ButtonProps = {
        color: 'secondary',
        disabled: disabled || disableForm,
        sx: { textTransform: 'none' }
    }

    return (
        <Stack
            id={id}
            sx={{
                textAlign: 'left',
                border: '1px solid rgb(200,200,200)',
                padding: '10px',
                borderRadius: '4px'
            }}
            spacing={2}
        >
            <Box
                id={`${id}-label`}
                sx={{
                    color: showError ? theme.palette.error.main : theme.palette.text.secondary
                }}
            >
                {showError ? errorMessage : `${label}${required ? ' *' : ''}`}
            </Box>
            <Stack direction='row' spacing={1}>
                <Button
                    id={`${id}-rock`}
                    variant={getButtonVariant('R')}
                    onClick={() => handleOnClick('R')}
                    {...buttonProps}
                >
                    Rock
                </Button>
                <Button
                    id={`${id}-paper`}
                    variant={getButtonVariant('P')}
                    onClick={() => handleOnClick('P')}
                    {...buttonProps}
                >
                    Paper
                </Button>
                <Button
                    id={`${id}-scissors`}
                    variant={getButtonVariant('S')}
                    onClick={() => handleOnClick('S')}
                    {...buttonProps}
                >
                    Scissors
                </Button>
                <Button
                    id={`${id}-dynamite`}
                    variant={getButtonVariant('D')}
                    onClick={() => handleOnClick('D')}
                    {...buttonProps}
                >
                    Dynamite
                </Button>
            </Stack>
        </Stack>
    )
}
